import { render } from "./corp.vue?vue&type=template&id=b7b93168&scoped=true"
import script from "./corp.vue?vue&type=script&lang=js"
export * from "./corp.vue?vue&type=script&lang=js"

import "./corp.vue?vue&type=style&index=0&id=b7b93168&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b93168"]])

export default __exports__